export default __webpack_public_path__ + "static/logo-52ac21f1cb4e4eacd2bbc2300d30e203.png";